export enum ChartOfAccountClassificationEnum {
  Input = 1,
  Output,
  Exempt
}

export namespace ChartOfAccountClassificationEnum {
  export function values() {
    return Object.keys(ChartOfAccountClassificationEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
